import * as services from '@/services/survey'
import { Message, MessageBox } from '@gcommon/gcommon-ui'
import { tran } from '@/utils/assist'
import { dealToXss } from '@/pages/Survey/AnswerSurvey/util'
import {
  LAST_TOPIC_WORD,
  NEXT_TOPIC_WORD,
  NORMAL_END_WORD,
  NOT_NEED_ORDER_TOPIC,
  NPS_MAX_WORD,
  NPS_MIN_WORD,
  SCALE_MAX_WORD,
  SCALE_MIN_WORD,
  TOPIC_DATA,
  NPS_TOPIC_TYPE
} from '@/pages/Survey/SurveyManagement/components/SurveyContent/config'
import { getNormalValue } from '@/pages/Survey/SurveyManagement/components/SurveyContent/util'
import {
  commitAnswerSurvey,
  getRandomList
} from '@/pages/Survey/SurveyManagement/components/SurveyContent/topicCommonUtil'
import { getErrorCode, getKey } from '@/utils/utils'

const setNormalValue = (item) => {
  item.topicSetting.lastPageText = getNormalValue(
    item.topicSetting.lastPageText,
    LAST_TOPIC_WORD
  )
  item.topicSetting.nextPageText = getNormalValue(
    item.topicSetting.nextPageText,
    NEXT_TOPIC_WORD
  )
  if (NPS_TOPIC_TYPE.indexOf(item.topicType) != -1) {
    item.topicSetting.minScoreDesc = getNormalValue(
      item.topicSetting.minScoreDesc,
      NPS_MIN_WORD
    )
    item.topicSetting.maxScoreDesc = getNormalValue(
      item.topicSetting.maxScoreDesc,
      NPS_MAX_WORD
    )
  } else {
    item.topicSetting.minScoreDesc = getNormalValue(
      item.topicSetting.minScoreDesc,
      SCALE_MIN_WORD
    )
    item.topicSetting.maxScoreDesc = getNormalValue(
      item.topicSetting.maxScoreDesc,
      SCALE_MAX_WORD
    )
  }
}

const initFunction = (payload) => {
  //初始化问卷数据
  let surveyData = dealToXss(payload || {})
  //给结束语默认值
  let order = 0 // 用于前端序号
  // surveyData.topics.sort((a, b) => a.orderNum - b.orderNum)
  surveyData.topics = surveyData.topics?.map((item) => {
    //给默认值
    setNormalValue(item)
    let titleTips = '' //题目提示语
    if (item.topicSetting.textLessThan) {
      titleTips = `${tran('survy.mostEnter')} ${
        item.topicSetting.textLessThan
      } ${tran('survy.char')}`
    }
    if (item.topicSetting.maxAppendixNum && item.topicType === 19) {
      //附件
      titleTips = `${tran('survy.mostupl')} ${
        item.topicSetting.maxAppendixNum
      } ${tran('survy.files')}`
    }
    //内部是否有选项随机排列
    if (item.topicSetting.isRandomOrder) {
      item.topicSetting.topicOptionSetting = getRandomList(
        item.topicSetting.topicOptionSetting
      )
    }
    //题号
    !NOT_NEED_ORDER_TOPIC.includes(item.topicType) && order++

    //当题目为矩阵题时，答案需要维护一个数组对象
    let matrixValue: Array<MatrixValueInterface> = []
    ;(item.matrixTopics || []).forEach((element) => {
      matrixValue.push({
        subTopicId: element.id,
        value: item.topicType == 9 ? [] : ''
      })
    })

    let inputValueObj = {} //正对单选、多选存在多输入框的处理
    ;(item.topicSetting.topicOptionSetting || []).forEach((element) => {
      inputValueObj['inputValue_' + element.optionId] = ''
      inputValueObj['inputErrorTips_' + element.optionId] = ''
    })

    //因为cem2.0单、多选题选择都可以输入文字，所以inputValue需要改成数组
    return Object.assign({}, item, {
      order, //是否需要序号
      isShowOrder: !surveyData?.surveyConfig?.isHiddenTopicNum,
      isAddStatus: false, //是否是新增
      isEditStatus: false, //是否可以编辑
      values: [], //多选时的值
      value: '', //单值
      inputErrorTips: '',
      ...inputValueObj,
      isShowTitleError: false, //是否在题目title处展示错误提示
      titleErrorTips: tran('survy.unfinished'), //题目title处展示错误提示
      matrixValue, //矩阵题的值，
      titleTips,
      display: true, //默认所有题目都展示
      key: getKey()
    })
  })
  surveyData.surveyConfig = Object.assign({}, surveyData.surveyConfig, {
    isAddStatus: false,
    isEditStatus: false
  })
  //默认结束语
  if (!surveyData.surveyConfig.endword) {
    surveyData.surveyConfig.endword = NORMAL_END_WORD
  }
  return surveyData
}

const state = {
  surveyConfigState: {
    surveyContent: {
      version: 1,
      isDraft: false,
      hasDraft: true,
      surveyConfig: {},
      topics: [],
      sourceFromType: 1,
      surveyStatus: 1
    },
    isShowSurveyConfig: false,
    isCheck: false, //是否是查看详情状态,
    isShowSurveyLogicConfig: false
  },
  surveyConfigNoDraftState: {
    surveyContent: {
      version: 1,
      isDraft: false,
      hasDraft: true,
      surveyConfig: {},
      topics: [],
      sourceFromType: 1,
      surveyStatus: 1
    },
    isShowSurveyConfig: false,
    isCheck: false, //是否是查看详情状态,
    isShowSurveyLogicConfig: false
  },
  targetDate: [],
  dynamicEvent: '',
  draftDet: {} //草稿态详情
}

const mutations = {
  commonMutations: (state, payload) => {
    Object.keys(payload).forEach((item) => {
      state[item] = payload[item]
    })
  },
  initState: (state, payload) => {
    let surveyData = initFunction(payload)
    state.surveyConfigState.surveyContent = surveyData
    state.dynamicEvent = surveyData.eventName
    state.draftDet = {}
  },
  noDraft: (state, payload) => {
    let surveyData = initFunction(payload)
    state.surveyConfigNoDraftState.surveyContent = surveyData
  },
  SET_TARGET_DATE: (state, data) => {
    state.targetDate = data
  }
}

const actions = {
  getSurveyDetailDraft({ state, commit }, payload) {
    services.checkSurveyDetialService(payload).then((res) => {
      if (res?.code == 200) {
        // commit('initState',res.data)
        // initSurveyData()
      }
    })
  },
  getSurveyDetailNoDraft({ state, commit }, payload) {
    services.checkSurveyDetialService(payload).then((res) => {
      if (res?.code == 200) {
        // commit('initState',res.data)
        // initSurveyData()
      }
    })
  },
  initFunc({ state, commit }) {
    commit('initGetSurveyDetail', { toAppliedLoading: true })
  }
  // toAppliedListHandleSearch ({ state, commit},payload=state.toAppliedParams) {
  //   commit('commonMutations',{toAppliedLoading:true})
  //   services.getTableDataToApplied(payload).then(res=>{
  //     if(res?.code === 200){
  //       if(res.data.page){
  //         res.data.page.total = res?.data?.page?.totalCount
  //       }else{
  //         res.data.page = {total:0}
  //       }
  //       commit('commonMutations',{toAppliedDataList:res?.data?.data,toAppliedPagination:res?.data.page})
  //     }
  //   })
  //   commit('commonMutations',{toAppliedLoading:false})
  //   commit('commonMutations',{toAppliedParams:payload})
  // },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
